<template>
  <iframe width="750" height="400" frameborder="0" :src="iFrameSrc"></iframe>
</template>
<style scoped>
div {
  max-height: 2%;
}
</style>
<script>
export default {
  name: 'MMP_ANSI_GoogleStreetView',
  props: ['iFrameSrc']
}
</script>
